import ShitSummaryReportFilterDataTable from "./ShitSummaryReportFilterDataTable";

export default ShitSummaryReportFilterDataTable;
